export const Warrantie = [
    {
        name: "Consultation générale",
        coverage: 75,
        limit: 200000,
        limitType: "50 Mega",
        serviceId: "Pharmacie"
    },
    {
        name: "Consultation générale",
        coverage: 75,
        limit: 200000,
        limitType: "50 Mega",
        serviceId: "Pharmacie"
    },
    {
        name: "Consultation générale",
        coverage: 75,
        limit: 200000,
        limitType: "50 Mega",
        serviceId: "Pharmacie"
    },
    {
        name: "Consultation générale",
        coverage: 75,
        limit: 200000,
        limitType: "50 Mega",
        serviceId: "Pharmacie"
    },
    {
        name: "Consultation générale",
        coverage: 75,
        limit: 200000,
        limitType: "50 Mega",
        serviceId: "Pharmacie"
    },
    {
        name: "Consultation générale",
        coverage: 75,
        limit: 200000,
        limitType: "50 Mega",
        serviceId: "Pharmacie"
    }
]